import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Grid,
  Paper,
  Avatar,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Chip
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShareIcon from '@mui/icons-material/Share';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import PermissionGate from '../CadastroPerfilUsuario/PermissionGate';
import URLManager from '../funcionalidadeNavbar/URLManager';

// Modernized TesteCalce form using multipart/form-data and image previews
export default function TesteCalce() {
  // Função para reenviar manualmente o link de avaliação
  // eslint-disable-next-line no-unused-vars
  const reenviarLink = async () => {
    if (!dialog.id) {
      setSnackbar({ open: true, severity: 'error', message: 'ID do teste não encontrado.' });
      return;
    }
    try {
      const res = await fetch(`${_url}/teste-calce/notificar/${dialog.id}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` }
      });
      if (!res.ok) {
        const txt = await res.text();
        setSnackbar({ open: true, severity: 'error', message: 'Falha ao reenviar: ' + txt });
      } else {
        setSnackbar({ open: true, severity: 'success', message: 'Link reenviado com sucesso!' });
      }
    } catch (e) {
      setSnackbar({ open: true, severity: 'error', message: 'Erro ao reenviar link.' });
    }
  };
  const { produtoId } = useParams();
  const navigate = useNavigate();
  const _url = URLManager.getBaseURL();

  const [produto, setProduto] = useState(null);
  const [nome, setNome] = useState('');
  const [telefoneWhatsapp, setTelefoneWhatsapp] = useState('');
  const [numeracaoPe, setNumeracaoPe] = useState('');

  // file inputs
  const [file1, setFile1] = useState(null);
  const [file2, setFile2] = useState(null);
  const [file3, setFile3] = useState(null);
  const [file4, setFile4] = useState(null);
  const [file5, setFile5] = useState(null);
  const [preview1, setPreview1] = useState(null);
  const [preview2, setPreview2] = useState(null);
  const [preview3, setPreview3] = useState(null);
  const [preview4, setPreview4] = useState(null);
  const [preview5, setPreview5] = useState(null);

  // region image URLs from product
  const [regionImages, setRegionImages] = useState({});

  // flags (grouped per image) - updated to match backend field names
  const [flags, setFlags] = useState({
    img1_incomodando_calcanhar: false,
    img1_saindo_do_pe_ao_andar: false,
    img1_descolando_parte_traseira_da_sola: false,
    img1_normal: false,

    img2_incomodando_frente: false,
    img2_incomodando_centro_do_pe: false,
    img2_incomodando_parte_de_tras: false,
    img2_solado_descolando: false,
    img2_normal: false,

    img3_apertado: false,
    img3_pressionando_dedos: false,
    img3_solado_descolando_no_bico: false,
    img3_normal: false,

    img4_incomodando_flexao: false,
    img4_cabedal_nao_flexiona: false,
    img4_solado_descolando_na_area_da_felxao: false,
    img4_normal: false,

    img5_entrada_do_pe_com_dificuldade: false,
    img5_apertando_peito_pe: false,
    img5_folgado_peito_pe: false,
    img5_normal: false
  });

  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, severity: 'info', message: '' });
  const [dialog, setDialog] = useState({ open: false, link: '', id: null });
  const [imagePreview, setImagePreview] = useState({ open: false, src: '' });

  // Prepare for adding another tester without leaving the page
  const resetForNext = () => {
    setNome('');
    setTelefoneWhatsapp('');
    setNumeracaoPe('');
    setFlags(prev => {
      const cleared = { ...prev };
      Object.keys(cleared).forEach(k => { cleared[k] = false; });
      return cleared;
    });
    // Mantemos as imagens selecionadas (previews/files) como padrão do produto,
    // para agilizar os próximos cadastros. Se quiser limpar também, podemos adicionar aqui.
  };

  // try to resolve produto info from product list (uses setProduto so setter isn't flagged unused)
  useEffect(() => {
    if (!produtoId) return;
    (async () => {
      try {
        const res = await fetch(`${_url}/produto/pais`, { headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` } });
        if (!res.ok) return;
        const list = await res.json();
        const p = list.find(x => Number(x.idProduto) === Number(produtoId));
        if (p) {
          setProduto(p);
          setRegionImages({
            1: p.imagemTraseira || null,
            2: p.imagemSolado || null,
            3: p.imagemBico || null,
            4: p.imagemFlexao || null,
            5: p.imagemPeitoPe || null
          });
        }
      } catch (e) {
        // ignore
      }
    })();
  }, [produtoId, _url]);

  const markNotified = async (id) => {
    if (!id) return;
  try {
  const res = await fetch(`${_url}/teste-calce/notificar/${id}`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` }
      });
      if (!res.ok) {
        const txt = await res.text();
        setSnackbar({ open: true, severity: 'error', message: 'Falha ao marcar notificado: ' + txt });
      } else {
        setSnackbar({ open: true, severity: 'success', message: 'Registro marcado como notificado' });
      }
    } catch (e) {
      console.error('markNotified error', e);
      setSnackbar({ open: true, severity: 'error', message: 'Erro ao marcar notificado' });
    }
  };

  const handleShare = async () => {
    const url = dialog.link;
    if (!url) return;
    // Use Web Share API when available
  if (navigator.share) {
      try {
        await navigator.share({
          title: 'Avaliação de Calce',
          text: 'Por favor, avalie este produto',
          url
        });
        setSnackbar({ open: true, severity: 'success', message: 'Compartilhado com sucesso' });
        // mark notified
        if (dialog.id) await markNotified(dialog.id);
        // close dialog and permanencer na tela para cadastrar outro
        setDialog({ open: false, link: '', id: null });
        resetForNext();
        return;
      } catch (e) {
        // user cancelled or error, fallback
        console.error('Share failed', e);
      }
    }

    // Fallback to WhatsApp share
    try {
      const msg = encodeURIComponent('Por favor avalie este produto:') + '%20' + encodeURIComponent(url);
      window.open(`https://api.whatsapp.com/send?text=${msg}`, '_blank');
      setSnackbar({ open: true, severity: 'info', message: 'Abrindo WhatsApp (fallback)...' });
      if (dialog.id) await markNotified(dialog.id);
      // Após abrir o WhatsApp, feche o diálogo e mantenha na mesma tela
      setDialog({ open: false, link: '', id: null });
      resetForNext();
    } catch (e) {
      setSnackbar({ open: true, severity: 'error', message: 'Não foi possível compartilhar' });
    }
  };

  const openPreview = (src) => {
    if (!src) return;
    setImagePreview({ open: true, src });
  };

  const closePreview = () => setImagePreview({ open: false, src: '' });

  const MAX_FILE_SIZE = 3 * 1024 * 1024; // 3MB

  const IMG_LABELS = {
    1: 'Traseira',
    2: 'Solado',
  3: 'Bico',
  4: 'Flexao',
    5: 'Peito do Pé'
  };

  const COLORS = ['#3f51b5','#ff7043','#ffca28','#66bb6a','#29b6f6'];

  const handleFileSelect = (i, f) => {
    if (!f) return;
    if (!f.type || !f.type.startsWith('image')) {
      setSnackbar({ open: true, severity: 'error', message: 'Arquivo inválido: apenas imagens são permitidas.' });
      return;
    }
    if (f.size > MAX_FILE_SIZE) {
      setSnackbar({ open: true, severity: 'error', message: 'Arquivo muito grande: máximo 3MB.' });
      return;
    }
    // Read file as data URL for preview
    const reader = new FileReader();
    reader.onload = async (ev) => {
      const dataUrl = ev.target.result;
      try {
        if (i === 1) { setFile1(f); setPreview1(dataUrl); }
        if (i === 2) { setFile2(f); setPreview2(dataUrl); }
        if (i === 3) { setFile3(f); setPreview3(dataUrl); }
        if (i === 4) { setFile4(f); setPreview4(dataUrl); }
        if (i === 5) { setFile5(f); setPreview5(dataUrl); }
      } catch (e) {
        // ignore reader errors
      }
    };
    reader.readAsDataURL(f);
  };

  // ...existing code...

  // ...existing code...

  // previews are stored as dataURLs when files are selected, and restored from localStorage

  const handleFlagChange = (key, value) => setFlags(prev => ({ ...prev, [key]: value }));

  const normalizePhone = (phone) => {
    if (!phone) return '';
    const p = phone.trim();
    if (p.startsWith('+')) return p;
    const digits = p.replace(/\D/g, '');
    return digits.startsWith('55') ? `+${digits}` : `+55${digits}`;
  };

  // submit handler: prefer JSON with remote image URLs when no local files; fallback to multipart when files/data URLs exist
  const handleSubmit = async () => {
    if (!produtoId || !produto) {
      setSnackbar({ open: true, severity: 'error', message: 'Produto não selecionado.' });
      return;
    }
    setLoading(true);

    try {
      const normalizedPhone = normalizePhone(telefoneWhatsapp || '');
      if (!normalizedPhone || !/^\+\d{11,15}$/.test(normalizedPhone)) {
        setSnackbar({ open: true, severity: 'error', message: 'Telefone inválido. Use +5511...' });
        setLoading(false);
        return;
      }

      // Sempre envia como FormData
      const fd = new FormData();
      fd.append('produtoId', String(produtoId));
      fd.append('nome', nome || '');
      fd.append('telefoneWhatsapp', normalizedPhone);
      if (numeracaoPe) fd.append('numeracaoPe', numeracaoPe);
      if (file1) fd.append('imagem1', file1);
      if (file2) fd.append('imagem2', file2);
      if (file3) fd.append('imagem3', file3);
      if (file4) fd.append('imagem4', file4);
      if (file5) fd.append('imagem5', file5);
      Object.keys(flags).forEach(k => fd.append(k, flags[k] ? 'true' : 'false'));
      let res = await fetch(`${_url}/teste-calce`, {
        method: 'POST',
        body: fd,
        headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` }
      });

      if (!res) {
        setSnackbar({ open: true, severity: 'error', message: 'Erro ao enviar' });
      } else if (!res.ok) {
        const txt = await res.text();
        setSnackbar({ open: true, severity: 'error', message: `Erro: ${txt}` });
      } else {
        const data = await res.json();
        const publicLink = `${window.location.origin}/qualidade/avaliar/${data.id}`;
        setDialog({ open: true, link: publicLink, id: data.id });
        try {
          const notifyRes = await fetch(`${_url}/teste-calce/notificar/${data.id}`, {
            method: 'POST',
            headers: { Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}` }
          });
          const ntBody = await notifyRes.text();
          if (!notifyRes.ok) {
            console.error('notify failed', { status: notifyRes.status, body: ntBody });
            setSnackbar({ open: true, severity: 'error', message: `Cadastro salvo. Falha ao confirmar envio automático: ${notifyRes.status}` });
          } else {
            setSnackbar({ open: true, severity: 'success', message: 'Link enviado (ou agendado) via WhatsApp.' });
          }
        } catch (ne) {
          console.error('notify error', ne);
          setSnackbar({ open: true, severity: 'error', message: 'Cadastro salvo. Falha ao acionar envio automático.' });
        }
      }
    } catch (e) {
      setSnackbar({ open: true, severity: 'error', message: 'Erro ao enviar' });
      console.error(e);
    } finally {
      setLoading(false);
    }
  };


  if (!produto) return <Box sx={{ padding: 3 }}><Typography>Produto não encontrado</Typography></Box>;

  return (
    <Box sx={{ padding: 3 }}>
      <Paper sx={{ p: 3, display: 'flex', gap: 3, alignItems: 'flex-start' }} elevation={2}>
        <Box sx={{ width: 260, textAlign: 'center' }}>
          <Avatar
            variant="rounded"
            src={produto.image ? (produto.image.startsWith('http') ? produto.image : `data:image/jpeg;base64,${produto.image}`) : ''}
            imgProps={{ style: { objectFit: 'contain' } }}
            sx={{ width: 220, height: 220, margin: '0 auto', bgcolor: '#fff' }}
          />
          <Typography variant="h6" sx={{ mt: 2 }}>{produto.nomeModelo}</Typography>
          <Typography variant="caption" display="block">Ref: {produto.referencia}</Typography>
        </Box>

        <Box sx={{ flex: 1 }}>
          <Paper sx={{ p: 2, background: '#fafafa', borderRadius: 2, mb: 2 }} elevation={0}>
            <Typography sx={{ fontWeight: 800, mb: 1 }}>Dados do testado</Typography>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} sm={6}>
                <TextField label="Nome" value={nome} onChange={e => setNome(e.target.value)} fullWidth placeholder="Nome do testador" />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label="Telefone (WhatsApp) "
                  value={telefoneWhatsapp}
                  onChange={e => setTelefoneWhatsapp(e.target.value)}
                  fullWidth
                  placeholder="+5511999999999"
                  // helperText=" Não informe o digito 9"
                  inputProps={{ pattern: '^\\+\\d{11,15}$' }}
                />
              </Grid>
             
              <Grid item xs={12} sm={4}>
                <TextField label="Numeração do pé" value={numeracaoPe} onChange={e => setNumeracaoPe(e.target.value)} fullWidth placeholder="Ex: 38"  />
              </Grid>
              <Grid item xs={12} sm={8}>
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 1 }}>
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={loading}
                    sx={{
                      background: 'linear-gradient(90deg,#667eea,#29b6f6)',
                      color: '#fff',
                      '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 8px 20px rgba(47,79,255,0.12)' },
                      transition: 'all 0.18s ease',
                      px: 3
                    }}
                  >
                    {loading ? 'Enviando...' : 'Enviar'}
                  </Button>
                  <Button variant="outlined" onClick={() => navigate(-1)} sx={{ px: 2 }}>Voltar</Button>
                </Box>
              </Grid>
            </Grid>
          </Paper>

            {/* Image upload blocks */}
            <Grid container spacing={2} direction="column" alignItems="stretch" sx={{ mt: 2 }}>
              {[1,2,3,4,5].map(i => {
                const hasProductImage = regionImages[i];
                let previewSrc = hasProductImage
                  ? regionImages[i]
                  : (i===1 ? preview1 : i===2 ? preview2 : i===3 ? preview3 : i===4 ? preview4 : preview5);
                return (
                  <Grid item xs={12} key={i}>
                    <Paper sx={{ width: '100%', p: 2, transition: 'transform 0.18s ease, box-shadow 0.18s', '&:hover': { transform: 'translateY(-6px)', boxShadow: '0 12px 30px rgba(2,6,23,0.08)' } }}>
                      <Chip label={IMG_LABELS[i]} size="small" sx={{ bgcolor: COLORS[(i-1) % COLORS.length], color: '#fff', mb: 1 }} />
                      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mt: 1 }}>
                        <Box sx={{ width: 120, height: 120, border: '1px dashed #ccc', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', borderRadius: 1, background: '#fff' }}>
                          {previewSrc ? <img src={previewSrc} alt={IMG_LABELS[i]} style={{ width: '100%', height: '100%', objectFit: 'contain', display: 'block' }} /> : <Typography variant="caption">Sem imagem</Typography>}
                        </Box>
                        <Box sx={{ flex: 1 }}>
                          <PermissionGate permissions={['cadastrarTesteCalce']}>
                            <Button variant="outlined" component="label" size="small" sx={{ textTransform: 'none' }} disabled={!!hasProductImage}>
                              {hasProductImage ? 'Imagem cadastrada' : 'Escolher arquivo'}
                              <input hidden accept="image/*" type="file" disabled={!!hasProductImage} onChange={e => {
                                const f = e.target.files && e.target.files[0];
                                if (!f) return;
                                handleFileSelect(i, f);
                              }} />
                            </Button>
                          </PermissionGate>
                          <Box sx={{ mt: 1 }}>
                            {/* checkboxes per image - simplified labels */}
                            {i===1 && (
                              <>
                                <FormControlLabel control={<Checkbox checked={flags.img1_incomodando_calcanhar} onChange={e => handleFlagChange('img1_incomodando_calcanhar', e.target.checked)} />} label="Incomodando calcanhar" />
                                <FormControlLabel control={<Checkbox checked={flags.img1_saindo_do_pe_ao_andar} onChange={e => handleFlagChange('img1_saindo_do_pe_ao_andar', e.target.checked)} />} label="Saindo do pé ao andar" />
                                <FormControlLabel control={<Checkbox checked={flags.img1_descolando_parte_traseira_da_sola} onChange={e => handleFlagChange('img1_descolando_parte_traseira_da_sola', e.target.checked)} />} label="Descolando parte traseira da sola" />
                                <FormControlLabel control={<Checkbox checked={flags.img1_normal} onChange={e => handleFlagChange('img1_normal', e.target.checked)} />} label="Normal" />
                              </>
                            )}
                            {i===2 && (
                              <>
                                <FormControlLabel control={<Checkbox checked={flags.img2_incomodando_frente} onChange={e => handleFlagChange('img2_incomodando_frente', e.target.checked)} />} label="Incomodando frente" />
                                <FormControlLabel control={<Checkbox checked={flags.img2_incomodando_centro_do_pe} onChange={e => handleFlagChange('img2_incomodando_centro_do_pe', e.target.checked)} />} label="Incomodando centro do pé" />
                                <FormControlLabel control={<Checkbox checked={flags.img2_incomodando_parte_de_tras} onChange={e => handleFlagChange('img2_incomodando_parte_de_tras', e.target.checked)} />} label="Incomodando parte de trás" />
                                <FormControlLabel control={<Checkbox checked={flags.img2_solado_descolando} onChange={e => handleFlagChange('img2_solado_descolando', e.target.checked)} />} label="Solado descolando" />
                                <FormControlLabel control={<Checkbox checked={flags.img2_normal} onChange={e => handleFlagChange('img2_normal', e.target.checked)} />} label="Normal" />
                              </>
                            )}
                            {i===3 && (
                              <>
                                <FormControlLabel control={<Checkbox checked={flags.img3_apertado} onChange={e => handleFlagChange('img3_apertado', e.target.checked)} />} label="Apertado" />
                                <FormControlLabel control={<Checkbox checked={flags.img3_pressionando_dedos} onChange={e => handleFlagChange('img3_pressionando_dedos', e.target.checked)} />} label="Pressionando dedos" />
                                <FormControlLabel control={<Checkbox checked={flags.img3_solado_descolando_no_bico} onChange={e => handleFlagChange('img3_solado_descolando_no_bico', e.target.checked)} />} label="Solado descolando no bico" />
                                <FormControlLabel control={<Checkbox checked={flags.img3_normal} onChange={e => handleFlagChange('img3_normal', e.target.checked)} />} label="Normal" />
                              </>
                            )}
                            {i===4 && (
                              <>
                                <FormControlLabel control={<Checkbox checked={flags.img4_incomodando_flexao} onChange={e => handleFlagChange('img4_incomodando_flexao', e.target.checked)} />} label="Incomodando flexão" />
                                <FormControlLabel control={<Checkbox checked={flags.img4_cabedal_nao_flexiona} onChange={e => handleFlagChange('img4_cabedal_nao_flexiona', e.target.checked)} />} label="Cabedal não flexiona" />
                                <FormControlLabel control={<Checkbox checked={flags.img4_solado_descolando_na_area_da_felxao} onChange={e => handleFlagChange('img4_solado_descolando_na_area_da_felxao', e.target.checked)} />} label="Solado descolando na área da flexão" />
                                <FormControlLabel control={<Checkbox checked={flags.img4_normal} onChange={e => handleFlagChange('img4_normal', e.target.checked)} />} label="Normal" />
                              </>
                            )}
                            {i===5 && (
                              <>
                                <FormControlLabel control={<Checkbox checked={flags.img5_entrada_do_pe_com_dificuldade} onChange={e => handleFlagChange('img5_entrada_do_pe_com_dificuldade', e.target.checked)} />} label="Entrada do pé com dificuldade" />
                                <FormControlLabel control={<Checkbox checked={flags.img5_apertando_peito_pe} onChange={e => handleFlagChange('img5_apertando_peito_pe', e.target.checked)} />} label="Apertando no peito do pé" />
                                <FormControlLabel control={<Checkbox checked={flags.img5_folgado_peito_pe} onChange={e => handleFlagChange('img5_folgado_peito_pe', e.target.checked)} />} label="Folgado no peito do pé" />
                                <FormControlLabel control={<Checkbox checked={flags.img5_normal} onChange={e => handleFlagChange('img5_normal', e.target.checked)} />} label="Normal" />
                              </>
                            )}
                          </Box>
                          <Box sx={{ mt: 1, display: 'flex', gap: 1, alignItems: 'center' }}>
                            <Button startIcon={<PhotoLibraryIcon />} size="small" onClick={() => {
                              openPreview(previewSrc);
                            }}>Visualizar</Button>
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                );
              })}

              <Grid item xs={12}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <PermissionGate permissions={['cadastrarTesteCalce']}>
                    <Button variant="contained" onClick={handleSubmit} disabled={loading}>{loading ? 'Enviando...' : 'Enviar'}</Button>
                  </PermissionGate>
                  <Button variant="outlined" onClick={() => navigate(-1)}>Voltar</Button>
                </Box>
              </Grid>
            </Grid>
        </Box>
      </Paper>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar(s => ({ ...s, open: false }))}>
        <Alert severity={snackbar.severity} sx={{ width: '100%' }}>{snackbar.message}</Alert>
      </Snackbar>
      <Dialog open={dialog.open} onClose={() => { setDialog({ open:false, link: '', id: null }); resetForNext(); }}>
        <DialogTitle>Link de Avaliação</DialogTitle>
        <DialogContent>
          <Typography variant="body2">Compartilhe este link com o testador para que ele avalie o produto:</Typography>
          <Paper sx={{ p:1, mt:1, display: 'flex', alignItems: 'center', gap:1, wordBreak: 'break-all' }}>
            <Typography variant="body2" sx={{ flex: 1 }}>{dialog.link}</Typography>
            <IconButton size="small" onClick={async ()=>{
              try{ await navigator.clipboard.writeText(dialog.link); setSnackbar({ open:true, severity:'success', message:'Link copiado' }); }
              catch(e){ setSnackbar({ open:true, severity:'error', message:'Falha ao copiar' }); }
            }}>
              <ContentCopyIcon />
            </IconButton>
          </Paper>
        </DialogContent>
        <DialogActions>
          <PermissionGate permissions={["cadastrarTesteCalce"]}>
            <Button startIcon={<ShareIcon />} onClick={handleShare}>Compartilhar</Button>
            
            <Button onClick={()=>{ setDialog({ open:false, link: '', id: null }); resetForNext(); }}>Fechar</Button>
          </PermissionGate>
        </DialogActions>
      </Dialog>

      {/* Image preview dialog (used by openPreview/closePreview) */}
      <Dialog open={imagePreview.open} onClose={closePreview} maxWidth="md">
        <DialogTitle>Visualizar imagem</DialogTitle>
        <DialogContent sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2 }}>
          {imagePreview.src ? <img src={imagePreview.src} alt="preview" style={{ maxWidth: '100%', maxHeight: '70vh', display: 'block' }} /> : <Typography variant="body2">Sem imagem</Typography>}
        </DialogContent>
        <DialogActions>
          <Button onClick={closePreview}>Fechar</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
